import { jsx, jsxs } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { useMemo } from 'react';
import { ToggleButton } from 'react-aria-components';
import { Link, Icon } from '@zapier/design-system';
import { useSecondaryNavContext } from './SecondaryNavContext.es.js';
import { SecondaryNavItemContext } from './SecondaryNavItemContext.es.js';

const navItem = "_nav-item_y7n6l_1";
const navItemButton = "_nav-item-button_y7n6l_8";
const navItemLink = "_nav-item-link_y7n6l_24";
const navItemToggleButton = "_nav-item-toggle-button_y7n6l_62";
const styles = {
	navItem: navItem,
	navItemButton: navItemButton,
	navItemLink: navItemLink,
	navItemToggleButton: navItemToggleButton
};

const SecondaryNavItem = ({ children, className, itemKey, label, linkProps }) => {
  const { selectedItemKey, expandedSectionKeys, registerSelectedItemKey, registerExpandedSectionKeys } = useSecondaryNavContext();
  const isSelected = selectedItemKey === itemKey;
  const isExpanded = expandedSectionKeys.includes(itemKey);
  const onClick = (e) => {
    var _a;
    registerSelectedItemKey(itemKey);
    (_a = linkProps.onClick) === null || _a === void 0 ? void 0 : _a.call(linkProps, e);
  };
  const onToggle = () => {
    registerExpandedSectionKeys(isExpanded ? expandedSectionKeys.filter((k) => k !== itemKey) : [...expandedSectionKeys, itemKey]);
  };
  const submenuId = `${itemKey}-menu`;
  const contextValue = useMemo(() => ({
    itemId: itemKey,
    listId: submenuId
  }), [itemKey, submenuId]);
  return jsx(SecondaryNavItemContext.Provider, { value: contextValue, children: jsxs("li", { className: clsx(styles.navItem, className), "data-zds": true, children: [jsxs("div", { className: styles.navItemButton, "data-selected": isSelected, "data-zds": true, children: [jsx(Link, Object.assign({}, linkProps, { "aria-current": isSelected ? "page" : void 0, className: clsx(styles.navItemLink, linkProps.className), onClick, children: label })), children && jsx(ToggleButton, { "aria-controls": submenuId, "aria-expanded": isExpanded, "aria-label": isExpanded ? "Collapse menu" : "Expand menu", className: styles.navItemToggleButton, "data-expanded": isExpanded, "data-zds": true, isSelected: isExpanded, onChange: onToggle, children: jsx(Icon, { name: "arrowSmallDown", size: 20, isBlock: true }) })] }), children] }) });
};

export { SecondaryNavItem };
//# sourceMappingURL=SecondaryNavItem.es.js.map
